<template>
    <v-card>
        <v-card-title class="justify-center" style="font-size: 1.8em; font-weight: bold;">
            Visualizar Transação
        </v-card-title>
        <v-card-text v-if="transacao" style="font-size: 1.2em">
            <v-layout justify-space-between wrap>
                <v-flex xs12>
                    ID: <b>{{ transacao.txid }}</b>
                </v-flex>
                <v-flex xs12 class="mb-3">
                    ID Transação: <b>{{ transacao.transacaoIdentificacao }}</b>
                </v-flex>
                <v-flex xs5>
                    Status: <b>{{ transacao.status }}</b>
                </v-flex>
                <v-flex xs5>
                    Valor pago: <b>{{ transacao.valor | currency({ fractionCount: 2 }) }}</b>
                </v-flex>
                <v-flex xs5>
                    Data: <b>{{ dataAtualFormatada(transacao.calendario) }}</b>
                </v-flex>
                <v-flex xs5>
                    Nome do pagador: <b>{{ transacao.pagador }}</b>
                </v-flex>
                <v-flex xs5>
                    Documento: <b>{{ transacao.documento }}</b>
                </v-flex>
            </v-layout>
        </v-card-text>
        <v-layout justify-center v-else>
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-layout>
        <v-card-actions class="justify-center">
            <v-btn @click="$emit('fechar')" block>Fechar</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
  props: ['transacaoSelecionada'],
  data: () => ({
    transacao: undefined
  }),
  beforeMount () {
    if (this.transacaoSelecionada) this.pegarTransacaoPagPix()
  },
  watch: {
    transacaoSelecionada (val) {
      if (val) this.pegarTransacaoPagPix()
    }
  },
  methods: {
    dataAtualFormatada (dataCobranca) {
      let data = new Date(dataCobranca)
      let dia = data.getDate().toString().padStart(2, '0')
      let mes = (data.getMonth() + 1).toString().padStart(2, '0')
      let ano = data.getFullYear()
      let hora = data.getHours()
      let min = data.getMinutes()
      return dia + '/' + mes + '/' + ano + ' ' + hora + ':' + min
    },
    pegarTransacaoPagPix () {
      this.transacao = undefined
      const data = {
        method: 'GET',
        txid: this.transacaoSelecionada.txid
      }
      this.$store.dispatch('transacoesPagPixBank', data).then(json => {
        this.transacao = json
      })
    }
  }
}
</script>
